var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6034 1.84375C22.4838 1.77964 22.3491 1.74919 22.2135 1.75563C22.078 1.76207 21.9467 1.80516 21.8337 1.88031L18.5 4.09844V1.75C18.5 1.35218 18.342 0.970644 18.0607 0.68934C17.7794 0.408035 17.3978 0.25 17 0.25H2C1.60218 0.25 1.22064 0.408035 0.93934 0.68934C0.658035 0.970644 0.5 1.35218 0.5 1.75V12.25C0.5 12.6478 0.658035 13.0294 0.93934 13.3107C1.22064 13.592 1.60218 13.75 2 13.75H17C17.3978 13.75 17.7794 13.592 18.0607 13.3107C18.342 13.0294 18.5 12.6478 18.5 12.25V9.90625L21.8337 12.1291C21.9576 12.2095 22.1024 12.2515 22.25 12.25C22.4489 12.25 22.6397 12.171 22.7803 12.0303C22.921 11.8897 23 11.6989 23 11.5V2.5C22.9991 2.36506 22.9617 2.23287 22.8919 2.11737C22.8221 2.00187 22.7225 1.90734 22.6034 1.84375ZM17 12.25H2V1.75H17V12.25ZM21.5 10.0984L18.5 8.09875V5.90125L21.5 3.90625V10.0984Z",
    fill: "#0181BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/videoIcon.cbffd8d111409fe9c956caa0b27b6ade.svg";
export { ForwardRef as ReactComponent };